<template>
  <div>
    <div
      class="w-full h-full rounded-t-3xl px-32 py-12 flex flex-col overflow-auto"
      style="height: calc(100vh - 136px)"
    >
      <!-- Header -->
      <div class="space-y-1">
        <BaseText
          type="label"
          class="text-neutral-600"
        >
          Lens Settings
        </BaseText>
        <BaseText
          size="sm"
          class="text-neutral-500"
        >
          Adjust your company wide Lens settings including your data sources.
        </BaseText>
      </div>
      <!-- Divider -->
      <div class="border-t border-neutral-50 w-full my-7" />
      <div class="space-y-1">
        <BaseText
          type="label"
          class="text-neutral-600"
        >
          Data Sources
        </BaseText>
        <BaseText
          size="sm"
          class="text-neutral-500"
        >
          Connect your ad accounts and data enrichment platforms
        </BaseText>
      </div>
      <div v-if="dataSources.facebook.length > 0 || loadingSources">
        <div class="flex items-center gap-2 mb-3 mt-7">
          <MetaPlatformIcon class="text-primary-blue" />
          <BaseText
            type="label"
            size="sm"
            class="text-text-muted"
          >
            Meta
          </BaseText>
        </div>
        <!-- Data sources list -->
        <div
          v-if="loadingSources"
          class="flex items-center justify-start gap-2 flex-wrap"
        >
          <div
            v-for="i in 3"
            :key="i"
            class="w-full skeleton rounded-2xl"
            style="height: 58px"
          />
        </div>
        <div
          v-else
          class="flex items-center justify-start gap-2 flex-wrap fade-in"
        >
          <DataSourceCard
            v-for="dataSource in dataSources.facebook"
            :key="dataSource.connectionOwner"
            :data-source="dataSource"
            :is-owner="dataSource.connectionOwner === getUser.user_id"
            @editConnection="handleConnectFacebook(true)"
          />
        </div>
      </div>
      <div
        v-else
        class="flex flex-col gap-2 items-center justify-center h-full"
      >
        <BaseText
          type="label"
          class="text-neutral-500"
        >
          No Facebook connections found
        </BaseText>
        <BaseButton
          outlined
          @click="handleConnectFacebook"
        >
          Connect Facebook
        </BaseButton>
      </div>
    </div>
  </div>
</template>

<script>
import lensAPI from '@/api/lens'
import facebookAuthUrl from '@/api/config/FBAuthConfig'
import FirebaseAPI from '@/api/firebase'
import { mapGetters } from 'vuex'
import DataSourceCard from '../lens/DataSourceCard.vue'
import MetaPlatformIcon from '../globals/Icons/FilterIcons/Platforms/MetaPlatformIcon.vue'

export default {
  name: 'LensOverviewSettings',
  components: {
    DataSourceCard,
    MetaPlatformIcon
  },
  data () {
    return {
      loadingSources: true,
      dataSources: {
        facebook: []
      },

      // facebook config
      facebookAppId: '3940328152867361',
      redirectUri: encodeURIComponent(window.location.origin + '/connect-facebook-lens/success'),
      scope: 'public_profile,email,ads_read,business_management,pages_show_list,attribution_read,pages_read_engagement,pages_read_user_content'
    }
  },
  computed: {
    ...mapGetters('AuthModule', ['getUser', 'getTeam'])
  },
  async mounted () {
    await this.getTeamMembers()
    await this.getTeamFBConnections()
  },
  methods: {
    async getTeamMembers () {
      if (this.getTeam) {
        this.teamMembers = await FirebaseAPI.Teams.getTeamMembers()
      }
    },
    async getTeamFBConnections () {
      try {
        this.loadingSources = true
        const { data } = await lensAPI.Lens.getLensConnections()
        const allSources = data.user_connections

        for (const [platform, sources] of Object.entries(allSources)) {
          const platformConnections = sources.map((src) => ({
            ...src,
            created_by: this.teamMembers.find(member => member.id === src.connectionOwner) || { name: 'External user' }

          }))
          this.dataSources[platform] = platformConnections
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loadingSources = false
      }
    },
    handleConnectFacebook (edit = false) {
      this.isAuthenticating = true

      try {
        const popup = window.open(
          facebookAuthUrl,
          'facebook-auth',
          'width=600,height=600,scrollbars=yes,resizable=yes'
        )

        if (!popup) {
          throw new Error('Popup was blocked. Please allow popups for this site.')
        }

        const checkClosed = setInterval(() => {
          if (popup.closed) {
            clearInterval(checkClosed)
            if (this.isAuthenticating) {
              console.log('User cancelled authentication')
              this.isAuthenticating = false
            }
          }
        }, 1000)
      } catch (error) {
        console.error('Facebook authentication error:', error)
        this.isAuthenticating = false
      }
    }
  }
}
</script>

<style scoped>
.fade-in {
  animation: fadeIn 150ms ease-in-out;
}
@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}
</style>
